import { useState } from 'react'

import type { TActiveAssetType } from './eld-types'

interface IPendingAction {
  type: 'replace' | 'remove'
  value: string | null
}

export const useELDConfirmationState = () => {
  const [showRemoveConfirmation, setShowRemoveConfirmation] = useState(false)
  const [showReplaceConfirmation, setShowReplaceConfirmation] = useState(false)
  const [pendingAction, setPendingAction] = useState<IPendingAction | null>(null)
  const [confirmingAssetType, setConfirmingAssetType] = useState<TActiveAssetType | null>(null)

  const showRemoveDialog = (assetType?: TActiveAssetType) => {
    setPendingAction({ type: 'remove', value: null })
    if (assetType) {
      setConfirmingAssetType(assetType)
    }
    setShowRemoveConfirmation(true)
  }

  const showReplaceDialog = (value: string, assetType?: TActiveAssetType) => {
    setPendingAction({ type: 'replace', value })
    if (assetType) {
      setConfirmingAssetType(assetType)
    }
    setShowReplaceConfirmation(true)
  }

  const cancelConfirmation = () => {
    setShowRemoveConfirmation(false)
    setShowReplaceConfirmation(false)
    setPendingAction(null)
    setConfirmingAssetType(null)
  }

  const resetConfirmationState = () => {
    setShowRemoveConfirmation(false)
    setShowReplaceConfirmation(false)
    setPendingAction(null)
    setConfirmingAssetType(null)
  }

  return {
    cancelConfirmation,
    confirmingAssetType,
    pendingAction,
    resetConfirmationState,
    showRemoveConfirmation,
    showRemoveDialog,
    showReplaceConfirmation,
    showReplaceDialog
  }
}

export type { IPendingAction }
